module.exports = __webpack_public_path__ + "fonts/OpenSans-BoldItalic.84a81a48.ttf";